import { useEffect, useRef } from "react";
import { useTrackFeature } from "src/business-hooks/useTrackFeature.ts";
import { useSearchParamState } from "src/hooks/useSearchParams";
import {
  AI_EXPAND_SEARCH_PARAM,
  AI_EXPAND_VALUE,
} from "./AiToolboxSection.constants";
import { useChatStream } from "./AiToolboxSection.hooks.tsx";
import { AiToolboxSectionView } from "./AiToolboxSection.view";
import type { ChatInputHandle } from "./components/ChatInput/ChatInput.types";

const AiToolboxSection = () => {
  useTrackFeature("ai_toolbox_view");

  const [expandValue, setExpandValue] = useSearchParamState(
    AI_EXPAND_SEARCH_PARAM,
    null,
    { replace: true }
  );
  const isMaximized = expandValue === AI_EXPAND_VALUE;
  const chatInputRef = useRef<ChatInputHandle>(null);
  const wasLoadingRef = useRef(false);
  const chatStream = useChatStream();

  const { isLoading } = chatStream;

  // Focus editor after streaming finishes
  useEffect(() => {
    if (wasLoadingRef.current && !isLoading) {
      chatInputRef.current?.focus();
    }
    wasLoadingRef.current = isLoading;
  }, [isLoading]);

  return (
    <AiToolboxSectionView
      chatStream={chatStream}
      isMaximized={isMaximized}
      onMaximize={() => setExpandValue(AI_EXPAND_VALUE)}
      onCollapse={() => setExpandValue(null)}
      inputRef={chatInputRef}
    />
  );
};

export default AiToolboxSection;
